//值是函数集
export default{
	changeIsMobile(state,data){
		state.isMobile = data
	},
	
	changeNowRouteName(state,data){
		state.nowRouteName = data
	},
	
	changeWindow(state,data){
		state.winW = data.winW
		state.winH = data.winH
	},
	
	changeNavData(state,data){
		state.navData = data
	},
	
	changeLan(state,data){
		localStorage.setItem('nowLang', data);
		state.lan = data
	},
	
	changeNowNavId(state,data){
		state.nowNavId = data
	},
	changeOtherData(state,data){
		state.otherData = data
	},
	
	changeFriendLink(state,data){
		state.friendLink = data
	}
	
}


// WEBPACK FOOTER //
// ./src/store/mutations.js